import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { setEncounterAction as setEncounter } from '../../../../services/EncounterService/slice';
import { EncounterType } from '../../../../services/EncounterService/types/encounterTypes';

const DischargeDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const encounter = useAppSelector((state) => state.encounter.currentEncounter);

  // Check if encounter is cancelled
  const isEncounterCancelled = encounter?.status === 'CANCEL';

  const handleChange = (value: string) => {
    if (!encounter) return;
    
    const updated = {
      ...encounter,
      encounterInfo: {
        ...encounter.encounterInfo,
        dischargeDate: value,
      },
    } as EncounterType;
    dispatch(setEncounter(updated));
  };

  // Format date from API format to input format (YYYY-MM-DD)
  const formatDateForInput = (dateString: string | undefined) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch {
      return '';
    }
  };

  return (
    <TextField
      label="Discharge Date"
      type="date"
      size="small"
      value={formatDateForInput(encounter?.encounterInfo?.dischargeDate)}
      onChange={(e) => handleChange(e.target.value)}
      disabled={isEncounterCancelled}
      InputLabelProps={{ shrink: true }}
      sx={{ 
        width: '220px',
        '& .MuiInputBase-input': {
          backgroundColor: isEncounterCancelled ? '#f5f5f5' : 'inherit'
        }
      }}
      helperText={isEncounterCancelled ? 'Read-only (Encounter Cancelled)' : ''}
    />
  );
};

export default DischargeDateEdit;
